import React from "react";
import "../../styles/components/welcomeSheet/welcomeSheet.scss";
import WelcomeSheetMobile from "./WelcomeSheetMobile";
import WelcomeSheetWeb from "./WelcomeSheetWeb";

function WelcomeSheet(props) {
	const changeLang = (code) => {
		let arr = window.location.href.split("/");
		arr[3] = code;
		let adress = arr.reduce((a, b) => a + "/" + b);
		window.location.replace(adress);
	};

	if (props.isMobile) {
		return (
			<WelcomeSheetMobile
				sheetOpen={props.sheetOpen}
				onClose={props.onClose}
				changeLang={changeLang}
				config={props.config}
			/>
		);
	} else {
		return (
			<WelcomeSheetWeb
				sheetOpen={props.sheetOpen}
				onClose={props.onClose}
				changeLang={changeLang}
				config={props.config}
			/>
		);
	}
}

export default WelcomeSheet;
